import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getInitialPage } from '../../helper';

interface currentBookAttributes {
    name: string;
    bookId: string | null;
    classId: string | null;
    subjectId: string | null;
    isbn: string | null;
    currentPage: number;
}

const initialState: currentBookAttributes = {
    name: '',
    bookId: null,
    classId: null,
    subjectId: null,
    isbn: null,
    currentPage: 0,
};

const currentBookSlice = createSlice({
    name: 'currentBook',
    initialState,
    reducers: {
        setCurrentBookName: (
            state,
            action: PayloadAction<Pick<currentBookAttributes, 'name'>>
        ) => {
            state.name = action.payload.name;
        },
        setCurrentBookId: (state, action: PayloadAction<string>) => {
            state.bookId = action.payload;
        },
        setCurrentClassId: (state, action: PayloadAction<string>) => {
            state.classId = action.payload;
        },
        setCurrentSubjectId: (state, action: PayloadAction<string>) => {
            state.subjectId = action.payload;
        },
        setCurrentIsbn: (state, action: PayloadAction<string>) => {
            state.isbn = action.payload;
        },
        setPage: (
            state,
            action: PayloadAction<Pick<currentBookAttributes, 'currentPage'>>
        ) => {
            state.currentPage = action.payload.currentPage;
        },
    },
});

export const {
    setCurrentBookName,
    setCurrentBookId,
    setCurrentClassId,
    setCurrentSubjectId,
    setCurrentIsbn,
    setPage,
} = currentBookSlice.actions;
export default currentBookSlice.reducer;
